import * as Yup from "yup";
import { minLength, maxLength } from "../../../utils/passwordRules";
import {
  emailMaxLength,
  emailMinLength,
} from "../../../config/profileFieldLengths";
import auth0 from "auth0-js";
import { FormikHelpers } from "formik";
import auth0Config from "../../../utils/auth0ConfigHelper";
import { pushCustomEvent } from "../../../utils/customEventHelper";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";

export interface InitialValues {
  email: string;
  password: string;
  auth0Response: string;
}
export const initialValues: InitialValues = {
  email: "",
  password: "",
  auth0Response: "",
};

type ValidationSchema = (t: TFunction) => Yup.ObjectSchema<{
  email: string;
  password: string;
}>;

export const validationSchema: ValidationSchema = (t) =>
  Yup.object().shape({
    email: Yup.string()
      .email(t("error.validation.email.invalid"))
      .required(t("error.validation.email.required"))
      .min(
        emailMinLength,
        t("error.validation.newEmail.policy.lengthAtLeast", {
          n: emailMinLength,
        }),
      )
      .max(
        emailMaxLength,
        t("error.validation.newEmail.policy.lengthAtMost", {
          n: emailMaxLength,
        }),
      ),
    password: Yup.string()
      .required(t("error.validation.password.required"))
      .concat(minLength(t))
      .concat(maxLength(t)),
  });

export type HandleSubmit = (
  values: InitialValues,
  actions: FormikHelpers<InitialValues>,
) => Promise<void>;

type UseHandleSubmit = (
  webAuth: auth0.WebAuth,
  captcha?: auth0.Captcha,
) => { handleSubmit: HandleSubmit };

export const useHandleSubmit: UseHandleSubmit = (webAuth, captcha) => {
  const { t } = useTranslation();

  const handleSubmit: HandleSubmit = async (values, actions) => {
    const {
      dict: {
        signin: { title },
      },
    } = auth0Config;

    pushCustomEvent("login");
    const { email, password } = values;

    webAuth.login(
      {
        realm:
          title === "delegated-admin-app"
            ? "Delegated-Admin-App"
            : "Username-Password-Authentication",
        username: email,
        password: password,
        captcha: captcha?.getValue(),
      } as auth0.LoginOptions,
      (error) => {
        if (error) {
          captcha?.reload((error) => {
            if (error) {
              actions.setErrors({
                auth0Response: t("error.unspecific"),
              });
            }
          });
          actions.setErrors({
            auth0Response: t("error.unspecific"),
          });
        }
      },
    );

    actions.setSubmitting(false);
  };
  return { handleSubmit };
};
